import i18n from '@/i18n'
import { Dialog } from 'antd-mobile'
import { format } from 'date-fns'

/**
 * @param time 毫秒 默认2000
 * @returns
 */
export const sleep = (time: number = 2000) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(null)
    }, time)
  })
}

type Tree<T, CKey extends string> = {
  [K in CKey]: T[]
}
/**
 * 遍历一棵树，可通过callbackfn返回true来中断遍历并返回当前节点
 * @param tree
 */
export function forEachTree<T extends Tree<T, CKey>, CKey extends string = 'children'>(tree: T | T[], callbackfn: (value: T) => boolean | void, key?: CKey) {
  const k = key ?? ('children' as CKey)
  // 当前节点
  let res = null
  let list = null
  if (Array.isArray(tree)) list = tree
  else if (callbackfn(tree)) return tree
  else list = tree[k]

  if (list)
    list.find((t) => {
      res = forEachTree(t, callbackfn, k)
      return !!res
    })
  return res
}

/**
 * 用于避免用户禁用了弹出式窗口，导致我们异步请求后的window.open打开新窗口失败
 * 会弹窗让用户再点击一遍，然后同步调用，就不算弹出式窗口了
 * @param args
 * @returns
 */
export function windowOpen(...args: Parameters<typeof window.open>): Promise<Window> {
  return new Promise((res, ret) => {
    const win = window.open(...args)
    if (win) return res(win)
    // 打开失败了，弹窗让用户重新点一遍
    Dialog.confirm({
      title: i18n.t('common.openPage'),
      onCancel: () => ret('reject'),
      onConfirm: () => res(window.open(...args)),
      confirmText: i18n.t('common.confirmBtn'),
      cancelText: i18n.t('common.cancel'),
    })
  })
}

/** 格式化时间 */
export const formatTime = (timeStamp: Date | number | undefined, formatString = 'yyyy-MM-dd', defaultString = '') => {
  if (!timeStamp) {
    return defaultString
  }

  try {
    return format(timeStamp, formatString)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('parse timeStamp error，source timeStamp is ', timeStamp)
  }
  return ''
}


/**
 * @param prefix 唯一ID前缀
 * @returns
 */
export const uuid = (prefix = '') => prefix + Math.random().toString(36).slice(-8)